import { ChertoExperiments } from 'constants/experiments'
import { getChertoExperimentVariation } from 'selectors/experimentSelectors'

/** Impact's UTM source. Cashback, ShopBack and our other affiliates all send traffic through Impact. */
export const AFFILIATE_UTM_SOURCE = 'impact_radius'

/**
 * The customer was referred by an affiliate (GR-5145), so they are eligible for the
 * affiliate hide promo code experiment.
 *
 * A spoofed session is an agent booking for the customer, not the customer seeing checkout.
 */
export function selectIsAffiliatePromoCodeExperimentEligible(state: App.State): boolean {
  return state.utm.source === AFFILIATE_UTM_SOURCE && !state.auth.account.isSpoofed
}

/**
 * Affiliate-referred customers in the variant arm cannot add a promo code: the field is hidden and
 * codes are not applied. Ends paying an affiliate commission and a promo discount on the same order.
 */
export function selectIsPromoCodeHiddenForAffiliate(state: App.State): boolean {
  return selectIsAffiliatePromoCodeExperimentEligible(state) &&
    getChertoExperimentVariation(state, ChertoExperiments.affiliateHidePromoCode) === 'variant'
}
